module.exports = __webpack_public_path__ + "media/images/spree/frontend/content/orders/girls-2ec55152b4ba470028b4ec23ab6b30dc.jpg";